/* ============================================================
   video-autoplay-nudge.js  —  cross-browser muted autoplay helper
   Safari desktop refuses muted autoplay until the page has had ONE
   user gesture. This nudges every muted video to play on load, and
   again on the first scroll / tap / mouse-move / key (which Safari
   accepts as consent). Idempotent + harmless on Chrome/Firefox/iOS.
   Only ever plays videos that are already muted — never unmutes.
   ============================================================ */
(function () {
  'use strict';

  function playableVideos() {
    // Any muted, autoplay-intended video on the page.
    return Array.prototype.slice.call(
      document.querySelectorAll('video[autoplay], video[muted], video.ai-ugc-carousel__video, video.ai-video-el')
    );
  }

  function nudge() {
    playableVideos().forEach(function (v) {
      // Respect explicit user pause: skip if the user paused it themselves.
      if (v.dataset.userPaused === 'true') return;
      // SCOUT 2026-09-09: NEVER re-mute a video the user deliberately unmuted. If sound is on
      // (data-user-sound or simply currently unmuted), leave it alone — previously coming back
      // to the tab silently re-muted a UGC clip the shopper had turned the sound on for. We only
      // enforce muted-for-autoplay on videos that are still muted.
      if (v.dataset.userSound === 'true' || v.muted === false) {
        if (v.paused && v.dataset.userPaused !== 'true') {
          var pp = v.play(); if (pp && pp.catch) pp.catch(function () {});
        }
        return;
      }
      v.muted = true;                        // muted is required for autoplay
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* will retry on next gesture */ });
      }
    });
  }

  // Try immediately + once the DOM/media is ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nudge, { once: true });
  } else {
    nudge();
  }
  window.addEventListener('load', nudge, { once: true });

  // First real user gesture unlocks Safari-desktop autoplay for the session.
  var gestures = ['scroll', 'pointerdown', 'touchstart', 'keydown', 'mousemove', 'click'];
  function onFirstGesture() {
    nudge();
    gestures.forEach(function (evt) {
      window.removeEventListener(evt, onFirstGesture, true);
    });
  }
  gestures.forEach(function (evt) {
    window.addEventListener(evt, onFirstGesture, { capture: true, passive: true });
  });

  // Re-nudge when the tab becomes visible again (Safari pauses on tab switch).
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) nudge();
  });
})();
